<template>
  <template v-if="isMobile">
    <swiper
      class="services-swiper__swiper"
      :modules="modules"
      :breakpoints="{
        320: { slidesPerView: 2 },
        640: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 },
      }"
      :space-between="8"
      :speed="800"
      :navigation="{ nextEl: '.services-swiper__nav_next', prevEl: '.services-swiper__nav_prev' }"
    >
      <swiper-slide v-for="(service, index) in servicesList" :key="index" class="services-swiper__slide">
        <ServicesCard :service="service" />
      </swiper-slide>
    </swiper>

    <div class="services-swiper__nav-swiper">
      <div class="services-swiper__nav_prev">
        <app-svg id="arrow-left" width="15" height="15" />
      </div>
      <div class="services-swiper__nav_next">
        <app-svg id="arrow-right" width="15" height="15" />
      </div>
    </div>
  </template>

  <ul v-else class="services-list">
    <li v-for="(service, index) in servicesList" :key="index" class="services-list__item">
      <ServicesCard :service="service" />
    </li>

    <li class="services__list-item">
      <ServicesCard :service="{
              title: 'Cделка под защитой',
              alias: 'clientsafe',
              lid_text: 'Вы получаете не только качественную услугу, но и финансовую защиту на&nbsp;20&nbsp;000&nbsp;000&nbsp;₽'
            }" nolink />
    </li>
  </ul>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import ServicesCard from "@/components/ServicesCard.vue";

export default {
  name: "ServicesList",
  components: {
    ServicesCard,
    Swiper,
    SwiperSlide,
  },

  props: {
    servicesList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isMobile: false,
      modules: [Navigation],
    };
  },

  mounted() {
    this.matchMedia();
  },

  methods: {
    matchMedia() {
      const mediaQuery = window.matchMedia("(max-width: 639px)");

      if (mediaQuery.matches) {
        this.isMobile = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.services-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  flex-wrap: wrap;

  &__item {
    flex-shrink: 0;
  }
}

.services-swiper {
  &__swiper {
    min-width: 0;
  }
  
  &__nav-swiper {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex: none;
    display: flex;
    gap: 10px;
    color: $color_primary;

    .services-swiper__nav_prev,
    .services-swiper__nav_next {
      cursor: pointer;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      border: 1px solid $color_orange-50;
      display: flex;
      align-items: center;
      justify-content: center;

      &.swiper-button-disabled {
        color: $color_grey-15;
        border-color: $color_grey-15;
      }

      flex: none;
      transition: color 0.3s ease,
      border 0.3s ease;

      @include phone {
        width: 32px;
        height: 32px;

        svg {
          width: 12px;
          height: 12px;
        }
      }
    }

    @include tablet {
      // display: none;
      justify-content: space-between;
      margin-top: 28px;
    }
  }
}
</style>
